import React from 'react';

import { companyService, useCompany } from '@webtrader/core/services/company';
import { notificationsService } from '@webtrader/core/services/notifications';
import { userPreferenceService } from '@webtrader/core/services/userPreference';
import { socketService } from '@webtrader/core/socket';
import { EPublicMessageType, IPublicReceiver } from '@webtrader/core/socket/topics/public';

export const usePublicTopic = () => {
  const { company } = useCompany();

  const tenantId = company?.tenantId;

  React.useEffect(() => {
    if (!tenantId) {
      return () => {};
    }

    const onReceive: IPublicReceiver = (message) => {
      if (!message) {
        return;
      }

      switch (message.M) {
        case EPublicMessageType.NOTIFICATION:
          notificationsService.fetchNotificationSummary();
          break;
        case EPublicMessageType.ONE_CLICK:
          companyService.retrieveCompanyProfile().then(() => {
            userPreferenceService.getOCTUserPreference();
          });
          break;
        default:
          break;
      }
    };

    socketService.topics().public.subscribe({
      tenantId,
      receiver: onReceive
    });

    return () => {
      socketService.topics().public.unsubscribe({
        tenantId,
        receiver: onReceive
      });
    };
  }, [tenantId]);
};
